import React from "react";
import { connect } from "react-redux";
import { Provider } from "react-redux";
import store from "../../../stores/reduxStore";
import * as actions from "../../../actions/actions";

import StripeUpgradeForm from "../stripe-upgrade-form";
import PromoCode from "../promo-code";
import PriceExplanation from "../price-explanation";
import OptionalBillingInfo from "../optional-billing-info";
import ProFeatures from "../pro-features";
import OtherSignupLinks from "../other-signup-links";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const yearlyKey = "pro-yearly";

const AccountPrice = ({ yearlyPrice }) => {
    return (
        <div>
            <i className="ui_pro-accounts plan-pro font-xlarge" />
            <h1 className="font-xxlarge font-bold margin-b-l">NounPro</h1>
            <div className="price">
                {yearlyPrice === 39.99 ? (
                    <div className="price-sign-style">
                        <div className="price-dollar-sign">$</div>
                        <div className="price-dollars-bold">39</div>
                        <div className="price-cents-underline price-pro">
                            99
                        </div>
                        <div className="price-stacked-type">billed yearly</div>
                    </div>
                ) : (
                    <div>${yearlyPrice} billed yearly</div>
                )}
            </div>
        </div>
    );
};

class ProUpgradeBilling extends React.Component {
    state = {
        planType: "pro-yearly"
    };

    componentDidMount() {
        this.props.getUser();
    }

    handleSuccess = () => {
        if (this.props.source === "for-mac") {
            this.props.redirect("/for-mac/upgrade/confirm/");
            return;
        }

        this.props.redirect("/");
    };

    render() {
        let { plans, coupon } = this.props;
        let { planType } = this.state;
        let currentPlan = plans && plans[planType];

        let period = planType.split("-").pop();

        return (
            <div id="billing">
                <div id="stripe-form" className="no-ui-icon">
                    <section className="main-billing">
                        <div className="container row">
                            <div
                                id="account-price"
                                className="columns six account-price"
                            >
                                <AccountPrice
                                    yearlyPrice={
                                        this.props.plans["pro-yearly"].price
                                    }
                                />
                                <ProFeatures />
                                {this.props.source !== "for-mac" ? (
                                    <OtherSignupLinks />
                                ) : null}
                            </div>
                            <ul className="pro-upgrade-billing new-form columns six">
                                <StripeUpgradeForm
                                    showThankYou
                                    thankYouTitle="Thanks for your NounPro subscription!"
                                    onSuccess={this.handleSuccess}
                                    planKey={this.state.planType}
                                    buttonText="Upgrade like a Pro"
                                >
                                    {({
                                        form,
                                        submitButton,
                                        error,
                                        billingInfo
                                    }) => (
                                        <React.Fragment>
                                            <ol className="payment-information">
                                                <li>
                                                    <h2 className="form-header font-medium">
                                                        Payment Information
                                                    </h2>
                                                </li>
                                                {form}
                                                <OptionalBillingInfo>
                                                    {billingInfo}
                                                </OptionalBillingInfo>
                                            </ol>

                                            <li className="footer margin-t-l">
                                                <PriceExplanation
                                                    currentPlan={currentPlan}
                                                    coupon={coupon}
                                                    period={period}
                                                />
                                            </li>
                                            <li>
                                                <PromoCode coupon={coupon} />
                                            </li>
                                            <li className="margin-t-l">
                                                {submitButton}
                                                {error}
                                            </li>
                                        </React.Fragment>
                                    )}
                                </StripeUpgradeForm>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let { user, stripe } = state;
    let { coupon, purchaseTypes } = stripe;

    let plans = {};
    purchaseTypes
        .filter(p => !!p.period)
        .forEach(p => {
            plans[`${p.type}-${p.period}`] = {
                price: p.price / 100
            };
        });

    return {
        user,
        coupon,
        plans
    };
}

const WrappedForm = connect(
    mapStateToProps,
    {
        getUser: actions.getCurrentUser,
        redirect: actions.redirect
    }
)(ProUpgradeBilling);

export { WrappedForm };

export default props => (
    <Provider store={store}>
        <WrappedForm {...props} />
    </Provider>
);
